import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";

export function DeleteConfirmDialog({ open, onOpenChange, plan, loading, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delete Training Plan</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{plan?.title}"? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 pt-4">
          <Button onClick={() => onOpenChange(false)} variant="outline" className="flex-1">Cancel</Button>
          <Button
            data-testid="confirm-delete-plan-btn"
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white"
          >
            Delete Plan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
